import React, { Component, PropTypes } from 'react';

import {GridList, GridTile} from 'material-ui/GridList';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import './GridValues.css';
import GridValuesStyles from './GridValuesStyles';


const defaultProps = {
    data: []
};

class GridValues extends Component {
    constructor(props) {
        super(props);

        this.colors = ['#414BA0', '#50d055', '#009FFD'];

    }
    render() {
        const tableData = {}
        this.props.data.forEach((parameter)=> {
            if(tableData[parameter.category] == undefined) {
                tableData[parameter.category] = [];
            }
            let val = 0;
            if (parameter.reportValue != -1) {
                val = parameter.reportValue;
            }
            tableData[parameter.category].push({
                id: parameter.reportID,
                parameter_id: parameter.id,
                name: parameter.name,
                value: val
            });
        });

        const order = ["Google Analytics", "Wordpress", "Redes Sociales"];
        var formFields = [];
        order.forEach((keyOrder) => {
            Object.keys(tableData).forEach((k) => {
                if (k != "Indicadores Manuales") {
                    if (k === keyOrder) {
                        formFields.push({
                            category: k,
                            parameters: tableData[k]
                        });
                    }
                }
            });
        });

        const Sections = formFields.map((section, i)=>{
            const actualColor = this.colors[i];
            const t = section.category;
            const GridTiles = section.parameters.map((ng) => {
                var value = String(ng.value);
                if (value !== 'Infinity' && value !== 'NaN' && value !== 'NaN%') {
                    if (Number(value)) {
                        value = value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
                    }
                } else {
                    value = 0;
                }
                return (
                    <GridTile
                        key={ng.parameter_id}
                        title={ng.name}
                        titleStyle={GridValuesStyles.gridTitleStyle}
                    >
                        <div className="gridTileBody" style={{backgroundColor: actualColor, height: '100%'}}>
                            <p style={{ fontSize: 25, marginTop: -5 }}> {value} </p>
                        </div>
                    </GridTile>
                );
            });

            return (
                <div key={i}>
                    <Divider />
                    <Subheader style={GridValuesStyles.gridHeader}><b>{t}</b></Subheader>
                    <div style={GridValuesStyles.gridContainer}>
                        <GridList
                            style={GridValuesStyles.gridList}
                            cols={4}
                        >
                            {GridTiles}
                        </GridList>
                    </div>
                </div>
            );
        });
        return (
            <div>
                <div className="advisory">
                    Esta herramienta de medición presenta limitaciones de uso para la sección de Redes Sociales debido a limitantes inherentes a las API de cada servicio.<br/>Limitaciones conocidas:<br/><ul className="advisory-ul"><li>Para búsquedas mayores a 93 días, no se podrán recuperar estadísticas de Facebook.</li><li>El número de seguidores de Twitter es excluyente del periodo elegido.</li></ul>
                </div>
                <div className="dashboardNumbers">
                    {Sections}
                </div>
            </div>
        );
    }
}

GridValues.defaultProps = defaultProps;

export default GridValues;



// WEBPACK FOOTER //
// ./src/Components/GridValues/GridValues.jsx